import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import { TabPanelProps, TabsProps } from "../../types/interface";
import { useState, useEffect } from "react";
/**
 *
 * Reusable component to generate Tabs
 * @param {object} TabsProps
 * @property {object} tabsName
 * @property {SxProps} tabStyles
 *
 */

interface VisionStudioTabsProps extends TabsProps {
  tabValue: number;
  setTabValue: (value: number) => void;
}

const VisionStudioTabs: React.FC<VisionStudioTabsProps> = ({
  tabsName,
  tabStyles,
  tabValue,
  setTabValue,
}) => {
  // Get the current URL path for the comparison
  const currentPath = window.location.pathname;

  useEffect(() => {
    const savedPath = localStorage.getItem("currentPath");
    const savedTab = localStorage.getItem("activeTab");

    // If the path has changed, reset the tab to index 0
    if (savedPath !== currentPath) {
      localStorage.setItem("currentPath", currentPath);
      setTabValue(0);
      localStorage.setItem("activeTab", "0");
    } else if (savedTab !== null) {
      // Restore the last active tab if the path is the same
      setTabValue(Number(savedTab));
    }
  }, [currentPath]);

  // Removed useEffect that overrides parent tabValue

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    localStorage.setItem("imageToAnnotateId", "");
    localStorage.setItem("activeTab", newValue.toString());
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    //console.log(window.location.pathname);

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`unifynow-tabpanel-${index}`}
        aria-labelledby={`unifynow-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `unifynow-tab-${index}`,
      "aria-controls": `unifynow-tabpanel-${index}`,
    };
  }

  return (
    <>
      <Box>
        <Tabs
          key={tabValue}
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            background: "white",
            border: "2px solid rgb(245, 246, 249)",
            borderBottom: "0",
          }}
          TabIndicatorProps={{
            sx: {
              backgroundColor: "black",
              height: "2px",
            },
          }}
        >
          {tabsName?.map((tabs, index) => {
            return (
              <Tab
                key={`${tabs}-${index}`}
                sx={{ textTransform: "none" }}
                label={tabs.labelName}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </Box>
      <Box
        sx={{
          ...tabStyles,
          flexGrow: 1,
          backgroundColor: "#F5F6F9",
          overflowY: "scroll",
        }}
        height="calc(100vh -100px)"
      >
        {tabsName?.map((tabs, index) => {
          return (
            <>
              <CustomTabPanel value={tabValue ?? 0} index={index} key={index}>
                {tabs.componentName}
              </CustomTabPanel>
            </>
          );
        })}
      </Box>
    </>
  );
};

export default VisionStudioTabs;
